module.exports = __webpack_public_path__ + "img/trinidad-and-tobago.c5f270a4.png";